// When the booking page is embedded on another site (iframe), some browsers block site storage
// (e.g. Chrome incognito, "block third-party cookies"): just reading window.localStorage then
// throws and the whole app fails to start. In that case use an in-memory storage instead, so the
// page still works (values are only kept until the page is closed).
// Imported first in index.js, before any module reads storage.

const memoryStorage = () => {
  const data = new Map();
  return {
    getItem: (key) => (data.has(String(key)) ? data.get(String(key)) : null),
    setItem: (key, value) => { data.set(String(key), String(value)); },
    removeItem: (key) => { data.delete(String(key)); },
    clear: () => data.clear(),
    key: (index) => Array.from(data.keys())[index] ?? null,
    get length() { return data.size; },
  };
};

["localStorage", "sessionStorage"].forEach((name) => {
  try {
    const storage = window[name];
    const probe = "__restoclick_storage_probe__";
    storage.setItem(probe, probe);
    storage.removeItem(probe);
  } catch (e) {
    try {
      Object.defineProperty(window, name, { value: memoryStorage(), configurable: true });
    } catch (ignored) {
      // nothing more we can do; the app will use storage as usual
    }
  }
});
